import React from 'react'
import { Link } from 'react-router-dom'
import paths from '../../paths'
import { ProfileShort } from '../../store/commonTypes'
import './styles.sass'

interface Props {
    profile: ProfileShort
}

const UserInfoDescription: React.FunctionComponent<Props> = ({ profile }: Props) => {
    return (
        <div className="description">
            <span className={`gender gender_${profile.gender}`}>
                <Link to={paths.profile.toPath({ nick: profile.nick })} className="nick">
                    {profile.nick}
                </Link>
            </span>
            <p>
                {profile.country && (
                    <span className="location">
                        {profile.country}
                        {profile.region && `, ${profile.region}`}
                    </span>
                )}
            </p>
        </div>
    )
}

export default UserInfoDescription
